import React, { useEffect, useState } from "react";
import {
  TextField,
  Grid,
  Popover,
  Box,
  OutlinedInput,
  FormHelperText,
  MenuList,
  ListItemButton,
  ListItemText,
  Divider,
  Typography,
} from "@mui/material";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CustomButton from "../../shared/CustomButton";
// import { PickersDay } from "@mui/x-date-pickers";

export function DurationPicker({ formik, setTouched }) {
  // const [start, setStart] = useState(new Date().toLocaleString());
  // const [end, setEnd] = useState(new Date().toLocaleString());

  const [start, setStart] = useState(new Date().toISOString());
  const [end, setEnd] = useState(
    formik.values.expiryDate || new Date().toISOString()
  );
  const [selectedDays, setSelectedDays] = useState(null);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDurationOption, setSelectedDurationOption] = useState(
    formik.values.duration
  );

  //popover handlers
  const handleDurationPickerClick = (event) => {
    // if (formik.values.isNew) {
    setAnchorEl(event.currentTarget);
    setOpen(true);
    // }
  };
  // console.log(end);
  const handleCloseDurationPicker = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const formatDate = (date) => {
    const year = date.toLocaleString("default", { year: "numeric" });
    const month = date.toLocaleString("default", { month: "2-digit" });
    const day = date.toLocaleString("default", { day: "2-digit" });

    const formattedDate = [year, month, day].join("-");

    //formate date as BE format
    // const formattedDate = year + "-" + month + "-" + day;

    return formattedDate;
  };

  const handleApply = () => {
    formik.setFieldValue("duration", selectedDurationOption);
    formik.setFieldValue("expiryDate", formatDate(new Date(end)));
    if (formik.values.isNew)
      formik.setFieldValue("creationDate", formatDate(new Date(start)));

    formik.setFieldValue(
      "formatedExpiryDate",
      new Date(end).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    );
    setTouched(true);
    handleCloseDurationPicker();
  };

  const durationOptions = [
    { id: "SIX_MONTHS", label: "6 Months" },
    { id: "ONE_YEAR", label: "1 Year" },
    { id: "THREE_YEARS", label: "3 Years" },
    { id: "FIVE_YEARS", label: "5 Years" },
    { id: "CUSTOM", label: "Custom" },
  ];

  useEffect(() => {
    if (selectedDurationOption.id !== "CUSTOM") {
      const date = new Date(start);
      let duration;
      switch (selectedDurationOption.id) {
        case "SIX_MONTHS":
          duration = 6;
          break;
        case "ONE_YEAR":
          duration = 12;
          break;
        case "THREE_YEARS":
          duration = 36;
          break;
        case "FIVE_YEARS":
          duration = 60;
          break;
        default:
          break;
      }

      //add the duration
      date.setMonth(date.getMonth() + duration);

      //formate date as BE format
      const formattedDate = formatDate(date);

      //set end
      setEnd(formattedDate);
    }
  }, [start, selectedDurationOption]);

  useEffect(() => {
    const selected = Math.ceil(
      (new Date(end).getTime() - new Date(start).getTime()) /
        (1000 * 60 * 60 * 24)
    );

    setSelectedDays(selected);
  }, [start, end]);

  // useEffect(() => {
  //   if (formik.values.creationDate) {
  //     setStart(formik.values.creationDate);
  //   }
  // }, [formik.values.creationDate]);

  useEffect(() => {
    if (formik.values.expiryDate) {
      setEnd(formik.values.expiryDate);
    }
  }, [formik.values.expiryDate]);

  return (
    <Box>
      <OutlinedInput
        id="duration"
        name="duration"
        sx={{
          width: "180px",
          height: "36px",
          "& .MuiInputBase-root": { height: "36px" },
          "& .MuiOutlinedInput": { height: "36px" },
        }}
        value={formik.values.duration?.label}
        error={Boolean(formik.errors.duration)}
        endAdornment={
          <CalendarTodayIcon
            size="small"
            sx={{ fontSize: "1rem" }}
            onClick={handleDurationPickerClick}
          />
        }
        onClick={handleDurationPickerClick}
        // disabled={formik.values.isNew ? false : true}
        disabled={formik.values.status === "EXPIRED"}
      />
      {Boolean(formik.errors.expiryDate) && (
        <FormHelperText id="duration" error={true}>
          {formik.errors.expiryDate}
        </FormHelperText>
      )}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseDurationPicker}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          horizontal: "left",
          vertical: "top",
        }}
        elevation={2}
        sx={{
          marginRight: "50px",
          "& .MuiPopover-paper": {
            width: "800px",
            p: 2,
          },
          zIndex: 11000,
        }}
      >
        <Grid container justifyContent="center">
          <Grid item xs={2} sx={{ borderRight: "1px solid #dbdee6" }}>
            <MenuList sx={{ width: "100%" }}>
              {durationOptions.map((option) => {
                return (
                  <ListItemButton
                    key={option.id}
                    sx={{
                      padding: "8px",
                      maxHeight: "32px",
                      height: "32px",
                      width: "90%",
                      "&:hover": { backgroundColor: "#D4EDF3" },
                      backgroundColor:
                        selectedDurationOption?.id === option.id
                          ? "#D4EDF3"
                          : "#fffff",
                    }}
                    onClick={() => setSelectedDurationOption(option)}
                  >
                    <ListItemText
                      sx={{
                        color: "#050D2E",
                        "& .MuiTypography-root": {
                          fontWeight: "500",
                        },
                      }}
                    >
                      {option.label}
                    </ListItemText>
                  </ListItemButton>
                );
              })}
            </MenuList>
          </Grid>
          <Grid item xs={5}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <StaticDatePicker
                displayStaticWrapperAs="desktop"
                value={start}
                onChange={(newValue) => {
                  setStart(newValue.$d.toISOString());
                }}
                renderInput={(params) => <TextField {...params} />}
                disablePast={true}
                views={["year", "month", "day"]}
                openTo="day"
                disabled={
                  !formik.values.isNew || formik.values.status === "EXPIRED"
                }

                // renderDay={(day, selectedDays) => (
                //   <PickersDay
                //     sx={{ "& .selected": { backgroundColor: "red" } }}
                //   />
                // )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={5}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <StaticDatePicker
                displayStaticWrapperAs="desktop"
                value={end}
                onChange={(newValue) => {
                  setEnd(newValue.$d.toISOString());
                }}
                renderInput={(params) => <TextField {...params} />}
                disabled={
                  formik.values.status !== "EXPIRED" &&
                  selectedDurationOption?.id === "CUSTOM"
                    ? false
                    : true
                }
                disablePast={true}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Divider />
        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          sx={{ paddingTop: "20px" }}
        >
          <Typography>
            {`${new Date(start).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
            -
            ${new Date(end).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}

            (${selectedDays} days selected)`}
          </Typography>
          <CustomButton
            type="secondary"
            text="Cancel"
            action={handleCloseDurationPicker}
          />
          <div style={{ width: "10px" }}></div>
          <CustomButton
            type="update"
            text="Apply"
            action={handleApply}
            disabled={selectedDays <= 0 || formik.values.status === "EXPIRED"}
          />
        </Grid>
      </Popover>
    </Box>
  );
}
